import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { createStoreWithSelectors } from "@/helpers/createStoreWithSelectors";

interface ICookieConsentStore {
	isPreferencesOpen: boolean;
	openPreferences: () => void;
	closePreferences: () => void;
}

const useCookieConsentStore = create<ICookieConsentStore>()(
	devtools(
		(set) => ({
			isPreferencesOpen: false,
			openPreferences: () =>
				set({ isPreferencesOpen: true }, false, "openPreferences"),
			closePreferences: () =>
				set({ isPreferencesOpen: false }, false, "closePreferences"),
		}),
		{ name: "cookie-consent" },
	),
);

const useCookieConsentStoreWithShallow = createStoreWithSelectors(
	useCookieConsentStore,
);

export { useCookieConsentStore, useCookieConsentStoreWithShallow };
